export default "__VITE_ASSET__75rd9TgW__"